import { SET_SIDEBAR } from '../types/sidebar';

export const getSidebar = (payload) => {
  return {
    type: SET_SIDEBAR,
    payload,
  };
};
